export default {
  title: 'Contribución al KPI de Marketing por Microaudiencia (USD)',
  infoDialog: 'Contribución proyectada al KPI por microaudiencias demográficas',
  kpi: 'KPI'
}
